import { render, staticRenderFns } from "./RevenueList.vue?vue&type=template&id=278e6d2e&scoped=true&"
import script from "./RevenueList.vue?vue&type=script&lang=js&"
export * from "./RevenueList.vue?vue&type=script&lang=js&"
import style0 from "./RevenueList.vue?vue&type=style&index=0&id=278e6d2e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "278e6d2e",
  null
  
)

export default component.exports